import React from 'react';
import './DealerModalDialog.css';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import CloseIconBlack from '../../assets/icons/close-grey.svg';

function DealerModalDialog({props, showDialogWithHeader}) {
  const closeDialog = () => {
    props.closeDialog();
  };

  return (
    <>
      <Modal show={() => true} onHide={closeDialog} size='xl' id='dealer-connect-modal'>
        <Modal.Body data-testid='modal-body'>
          <div id='prequal--web--app'>
            <main className='prequal--web--app prequal--wc--app'>
              <div className='prequal--web-flex prequal--web--header-padding-fomo'>
                <span className='prequal-align--left prequal-flex__col-8 prequal--web--dialog-title-fomo'>
                  {showDialogWithHeader ? props.title : ''}
                </span>
                <span className='prequal--web--align-right prequal--web--flex--col-4 prequal--web--close-button'>
                  <button data-testid='modal-button' onClick={closeDialog} type='button'>
                    <img src={CloseIconBlack} alt='close' />
                  </button>
                </span>
              </div>
              {showDialogWithHeader && <div className='prequal--web--dialog-header-line' />}
              <div className='prequal--web--modal-content-fomo prequal--web--m--b-2'>{props.content()}</div>
            </main>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

DealerModalDialog.propTypes = {
  props: PropTypes.object,
  closeDialog: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.string,
  showDialogWithHeader: PropTypes.bool
};
DealerModalDialog.defaultProps = {
  props: {closeDialog: null, title: '', content: ''},
  closeDialog: null,
  title: '',
  content: '',
  showDialogWithHeader: false
};
export default DealerModalDialog;
